module.exports = __webpack_public_path__ + "img/user-add-c.b013497b.png";